import { render, staticRenderFns } from "./DiscountDialog.vue?vue&type=template&id=0b068dda&scoped=true"
import script from "./DiscountDialog.vue?vue&type=script&lang=js"
export * from "./DiscountDialog.vue?vue&type=script&lang=js"
import style0 from "./DiscountDialog.vue?vue&type=style&index=0&id=0b068dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b068dda",
  null
  
)

export default component.exports